import { ValidationResult } from '../typings/common';
import { PaymentData, WalletSwitchOffLimitEditPopupValue } from '../typings/walletState';

export const FETCH_PAYMENT_DATA = 'FETCH_PAYMENT_DATA';
export type FETCH_PAYMENT_DATA = typeof FETCH_PAYMENT_DATA;

export interface FetchPaymentData {
    type: FETCH_PAYMENT_DATA;
}

export function fetchPaymentData(): FetchPaymentData {
    return {
        type: FETCH_PAYMENT_DATA
    };
}

export const UPDATE_PAYMENT_DATA = 'UPDATE_PAYMENT_DATA';
export type UPDATE_PAYMENT_DATA = typeof UPDATE_PAYMENT_DATA;

export interface UpdatePaymentData {
    type: UPDATE_PAYMENT_DATA;
    paymentData: PaymentData;
}

export function updatePaymentData(paymentData: PaymentData): UpdatePaymentData {
    return {
        type: UPDATE_PAYMENT_DATA,
        paymentData
    };
}

export const UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY =
    'UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY';
export type UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY = typeof UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY;

export interface UpdateWalletSwitchOffLimitPopupVisibility {
    type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY;
    isVisible: boolean;
}

export function updateWalletSwitchOffLimitPopupVisibility(
    isVisible: boolean
): UpdateWalletSwitchOffLimitPopupVisibility {
    return {
        type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VISIBILITY,
        isVisible
    };
}

export const UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE = 'UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE';
export type UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE = typeof UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE;

export interface UpdateWalletSwitchOffLimitPopupValue {
    type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE;
    value: WalletSwitchOffLimitEditPopupValue;
}

export function updateWalletSwitchOffLimitPopupValue(
    value: WalletSwitchOffLimitEditPopupValue
): UpdateWalletSwitchOffLimitPopupValue {
    return {
        type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALUE,
        value
    };
}

export const UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE =
    'UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE';
export type UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE = typeof UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE;

export interface UpdateWalletSwitchOffLimitPopupSavingState {
    type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE;
    isSaving: boolean;
}

export function updateWalletSwitchOffLimitPopupSavingState(
    isSaving: boolean
): UpdateWalletSwitchOffLimitPopupSavingState {
    return {
        type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_SAVING_STATE,
        isSaving
    };
}

export const UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE =
    'UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE';
export type UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE = typeof UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE;

export interface UpdateWalletSwitchOffLimitPopupResettingState {
    type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE;
    isResetting: boolean;
}

export function updateWalletSwitchOffLimitPopupResettingState(
    isResetting: boolean
): UpdateWalletSwitchOffLimitPopupResettingState {
    return {
        type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_RESETTING_STATE,
        isResetting
    };
}

export const UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION =
    'UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION';
export type UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION = typeof UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION;

export interface UpdateWalletSwitchOffLimitPopupValidation {
    type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION;
    validationResult: ValidationResult;
}

export function updateWalletSwitchOffLimitPopupValidation(
    validationResult: ValidationResult
): UpdateWalletSwitchOffLimitPopupValidation {
    return {
        type: UPDATE_WALLET_SWITCH_OFF_LIMIT_EDIT_POPUP_VALIDATION,
        validationResult
    };
}

export const MAKE_RESET_WALLET_LIMIT_REQUEST = 'MAKE_RESET_WALLET_LIMIT_REQUEST';
export type MAKE_RESET_WALLET_LIMIT_REQUEST = typeof MAKE_RESET_WALLET_LIMIT_REQUEST;

export interface MakeResetWalletLimitRequest {
    type: MAKE_RESET_WALLET_LIMIT_REQUEST;
}

export function makeResetWalletLimitRequest(): MakeResetWalletLimitRequest {
    return {
        type: MAKE_RESET_WALLET_LIMIT_REQUEST
    };
}

export const RESET_WALLET_LIMIT = 'RESET_WALLET_LIMIT';
export type RESET_WALLET_LIMIT = typeof RESET_WALLET_LIMIT;

export interface ResetWalletLimit {
    type: RESET_WALLET_LIMIT;
    sum: string;
}

export function resetWalletLimit(sum: string): ResetWalletLimit {
    return {
        type: RESET_WALLET_LIMIT,
        sum
    };
}

export const MAKE_UPDATE_WALLET_LIMIT_REQUEST = 'MAKE_UPDATE_WALLET_LIMIT_REQUEST';
export type MAKE_UPDATE_WALLET_LIMIT_REQUEST = typeof MAKE_UPDATE_WALLET_LIMIT_REQUEST;

export interface MakeUpdateWalletLimitRequest {
    type: MAKE_UPDATE_WALLET_LIMIT_REQUEST;
}

export function makeUpdateWalletLimitRequest(): MakeUpdateWalletLimitRequest {
    return {
        type: MAKE_UPDATE_WALLET_LIMIT_REQUEST
    };
}

export const UPDATE_WALLET_LIMIT = 'UPDATE_WALLET_LIMIT';
export type UPDATE_WALLET_LIMIT = typeof UPDATE_WALLET_LIMIT;

export interface UpdateWalletLimit {
    type: UPDATE_WALLET_LIMIT;
}

export function updateWalletLimit(): UpdateWalletLimit {
    return {
        type: UPDATE_WALLET_LIMIT
    };
}

export type WalletSwitchOffLimitPopupAction =
    | MakeUpdateWalletLimitRequest
    | UpdateWalletLimit
    | MakeResetWalletLimitRequest
    | ResetWalletLimit
    | UpdateWalletSwitchOffLimitPopupValue
    | FetchPaymentData
    | UpdatePaymentData
    | UpdateWalletSwitchOffLimitPopupVisibility
    | UpdateWalletSwitchOffLimitPopupSavingState
    | UpdateWalletSwitchOffLimitPopupResettingState
    | UpdateWalletSwitchOffLimitPopupValidation;
